import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useManagePracticeDashboardEnabled = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.MANAGE_PRACTICE_DASHBOARD);
};
